// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__YHWXP","item":"Navigation_item__XDI+9","active":"Navigation_active__r7HTL","icon":"Navigation_icon__vEpMj"};